export function calculateAgeYears(dateOfBirth: Date, now: Date): number {
  if (now.getTime() <= dateOfBirth.getTime()) return 0;

  const dobYear = dateOfBirth.getUTCFullYear();
  const dobMonth = dateOfBirth.getUTCMonth();
  const dobDay = dateOfBirth.getUTCDate();
  const nowYear = now.getUTCFullYear();
  const nowMonth = now.getUTCMonth();
  const nowDay = now.getUTCDate();

  let years = nowYear - dobYear;
  const beforeThisYearsBirthday =
    nowMonth < dobMonth || (nowMonth === dobMonth && nowDay < dobDay);
  if (beforeThisYearsBirthday) years -= 1;

  const lastBirthday = new Date(Date.UTC(dobYear + years, dobMonth, dobDay));
  const nextBirthday = new Date(Date.UTC(dobYear + years + 1, dobMonth, dobDay));
  const fraction =
    (now.getTime() - lastBirthday.getTime()) /
    (nextBirthday.getTime() - lastBirthday.getTime());

  return years + fraction;
}
